<template>
    <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <inertia-link :href="$route('home')">
                <img alt="Logo" class="mx-auto h-12 w-auto" src="/images/logo.png" />
            </inertia-link>
            <h2 class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
                {{ $t('login.title') }}
            </h2>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <alert
                    class="mb-4"
                    :message.sync="$page.props.flash.error"
                    type="danger"
                    v-if="$page.props.flash.error"
                />
                <alert
                    class="mb-4"
                    :message.sync="$page.props.flash.success"
                    type="success"
                    v-if="$page.props.flash.success"
                />
                <form @submit.prevent="submit">
                    <div>
                        <label class="block text-sm font-medium leading-5 text-gray-700" for="email">
                            {{ $t('login.email') }}
                        </label>
                        <div class="mt-1 rounded-md shadow-sm">
                            <input
                                id="email"
                                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                required
                                type="email"
                                v-model="form.email"
                            />
                        </div>
                    </div>

                    <div class="mt-6">
                        <label class="block text-sm font-medium leading-5 text-gray-700" for="password">
                            {{ $t('login.password') }}
                        </label>
                        <div class="mt-1 rounded-md shadow-sm">
                            <input
                                id="password"
                                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                required
                                type="password"
                                v-model="form.password"
                            />
                        </div>
                    </div>

                    <div class="mt-6 flex items-center justify-between">
                        <div class="flex items-center">
                            <input
                                id="remember_me"
                                class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                                type="checkbox"
                                v-model="form.remember"
                            />
                            <label class="ml-2 block text-sm leading-5 text-gray-900" for="remember_me">
                                {{ $t('login.remember') }}
                            </label>
                        </div>

                        <div class="text-sm leading-5">
                            <a class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150" :href="$route('gestion.forgotpassword')">
                                {{ $t('login.forgot_password') }}
                            </a>
                        </div>
                    </div>

                    <div class="mt-6">
                        <span class="block w-full rounded-md shadow-sm">
                            <button class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" type="submit">
                                {{ $t('login.signin') }}
                            </button>
                        </span>
                    </div>
                </form>

                <div class="mt-6" v-if="false">
                    <div class="relative">
                        <div class="absolute inset-0 flex items-center">
                            <div class="w-full border-t border-gray-300" />
                        </div>
                        <div class="relative flex justify-center text-sm leading-5">
                            <span class="px-2 bg-white text-gray-500">
                                {{ $t('login.signin_with') }}
                            </span>
                        </div>
                    </div>

                    <div class="mt-6 grid grid-cols-3 gap-3">
                        <div>
                            <span class="w-full inline-flex rounded-md shadow-sm">
                                <button aria-label="Sign in with Facebook" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" type="button">
                                    <activix-icon fill="currentcolor" name="SocialMediasBold.SocialMediaFacebook" />
                                </button>
                            </span>
                        </div>

                        <div>
                            <span class="w-full inline-flex rounded-md shadow-sm">
                                <button aria-label="Sign in with Linkedin" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" type="button">
                                    <activix-icon fill="currentcolor" name="ProfessionalNetworksBold.ProfessionalNetworkLinkedin" />
                                </button>
                            </span>
                        </div>

                        <div>
                            <span class="w-full inline-flex rounded-md shadow-sm">
                                <button aria-label="Sign in with Google" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" type="button">
                                    <activix-icon fill="currentcolor" name="SocialMediasBold.SocialMediaGoogle" />
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Alert from '@/components/ui/Alert.vue';

    export default {
        components: {
            Alert,
        },

        data() {
            return {
                form: {
                    email: null,
                    password: null,
                    remember: false,
                },
            };
        },

        methods: {
            submit() {
                this.$inertia.post(this.$route('gestion.login'), this.form);
            },
        },
    };
</script>
